import React, { useState, useEffect, useRef } from 'react';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import { Loader, Dimmer } from 'semantic-ui-react';
import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../../components/mensajes';
import { GestionarMarca } from './gestionarMarca';
import useTable from "../../components/useTable";
import { formatMoneda } from '../../util/varios';

const TablaMarca = (props) => {

  var op = require('../../../public/modulos/datos');
  let token = sessionStorage.getItem('jwtToken');
  let municipios = [];

  const headCells = [
    { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD.', textAlign: 'center' },
    { id: '', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'DESCRIPCIÓN', textAlign: 'center' },
    { id: 'opciones', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: ' OPCIONES', textAlign: 'center' }
  ]

  const colores = [
    '#17a2b8',
    '#ffae00',
    '#dc3545',
    '#BDB76B',
    '#7B68EE',
    '#4B0082',
    '#00ffff',
    '#0080ff',
    '#0000ff',
    '#8000ff',
    '#ff00ff',
    '#ff0080',
  ];

  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
  const txtBuscador = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([
    {
      codigo:1,
      nombre:'JESUS',
      descripcion:'ALMACEN 1'
    }
  ]);
  const [expendedor, setExpendedor] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [persona, setPersona] = useState()
  const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
  const [ciudades, setCiudades] = useState()
  const [credito, setCredito] = useState();
  const [total, setTotal] = useState(0);
  const [activos, setActivos] = useState(0);
  const [inactivos, setInactivos] = useState(0);
  const [municipiosEx, setMunicipiosEx] = useState([]);
  const [municipiosData, setMunicipiosData] = useState([]);
  const [datos, setDatos] = useState([]);

  const {
    TblContainer,
    TblHead,
    recordsAfterPagingAndSorting,
    TblPagination
  } = useTable(records, headCells, filterFn);

  const handleSearch = e => {
    let target = e.target;
    let st = '';
    setFilterFn({
      fn: items => {
        if (target.value === "")
          return items;
        else
          return items.filter(x => {
            (st = x.status === '51' ? 'activo' : 'inactivo')
            if (x.idagente.includes(target.value)
              || x.nombre.toLowerCase().includes(target.value.toLowerCase())
              || x.rif.toLowerCase().includes(target.value.toLowerCase())
              || x.nrolicencia.toLowerCase().includes(target.value.toLowerCase())
              || st.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      }
    })

  }

  const gestionarExpendedor = (op, id) => (e) => {
    if (op === 4) {
      setOperacion(4);
   /*    getExpendedor(id); */
    } else if (op === 1) {
      setOperacion(op);
      setMostrar(true)
    } else if (op === 2) {
      setOperacion(op);
    /*   getExpendedor(id); */
    } else if (op === 3) {
      setOperacion(op);
/*       getExpendedor(id); */
    }
  }

  const selectCiudad = (id) => {
    let campos = '*';
    let nomtab = 'ciudad';
    let nomid = 'idmunicipio';
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios.get(endpoint, {
      headers: {
        'x-access-token': `${token}`
      }
    }).then(function (response) {
      if (response.status === 200) {
        setCiudades(response.data)
        setMostrar2(true)
      }
    }).catch(function (error) {
      setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
    })
  };

  const handleCancela2 = () => {
    setMostrar2(false);
    setExpendedor('')
    setCredito('')
  }

  const cerramodal = () => {
  
      setMostrar(false)

  }

  const handleCloseSi = () => {
    setActivate(false);
   /*  getExpendedor(); */
    setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })

  };

  useEffect(() => {

   /*  setActivate(true); */
  }, []);

  

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className='row col-md-12' style={{ margin: 0 }}>
          <div className='col-md-8 py-3 mx-auto mt-5'>
          
            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                <input type="text" className=" col-3 form-control form-control-sm rounded-pill" ref={txtBuscador} onChange={handleSearch} placeholder="Buscar" />
                <div className='col-3 d-flex justify-content-end'>
                  <button onClick={gestionarExpendedor(1, '')} style={{ marginBottom: "5px" }} className="btn btn-sm btn-primary rounded-circle"><i className="fas fa-plus"></i> </button>
                </div>
              </div>
            </div>
            <div className="col-md-12" style={{ margin: "auto" }} >
              <TblContainer>
                <TblHead />
                <TableBody >
                  {
                    records && recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>{item.codigo}</TableCell>
                        <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '270px' }}>{item.descripcion}</TableCell>
                        <TableCell className='align-baseline' style={{ textAlign: "center", alignItems: 'center' }}>
                          <button onClick={gestionarExpendedor(4, item.codigo)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i> </button>
                          <button onClick={gestionarExpendedor(2, item.codigo)} className="btn btn-sm mx-1 btn-warning rounded-circle"><i className="fa fa-edit"></i> </button>
                          <button onClick={gestionarExpendedor(3, item.codigo)} className="btn btn-sm mx-1 btn-danger rounded-circle"><i className="fa fa-trash"></i> </button>
                        </TableCell>
                      </TableRow>
                    ))
                  }
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
     
        </div>
      </div >

      <GestionarMarca 
      show={mostrar}
      onHideCancela={cerramodal}
      operacion={operacion}
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje mensaje={mensaje}
        onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
      <MensajeSiNo mensaje={mensajesino}
        onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
    </div>
  );
}
export default TablaMarca;


// WEBPACK FOOTER //
// ./src/components/almacen/tablaMarca.js